import React from 'react'

/**
 * $BILL Tokenomics2 (List)
 *
 * Drop-in React component converted from the provided HTML.
 * You can override the defaults via props.
 */
export default function Posts({ posts, total }) {
  return (
    <main
      id='tokenomics2'
      
    >
      <style>{`
        :root{
          --bg:#0f1115;
          --card:#161b22;
          --text:#e8eef4;
          --muted:#a7b3bf;
          --border:#232a33;
          --accent:#3aa0ff;
        }
        *{box-sizing:border-box;margin:0;padding:0}
        body:has(#tokenomics2){background:var(--bg);}
        #tokenomics2{background:var(--bg);color:var(--text);line-height:1.6;padding:28px 16px}
        #tokenomics2 main{max-width:700px;margin:auto}
        #tokenomics2 header{text-align:center;margin-bottom:24px}
        #tokenomics2 .badge{display:inline-block;padding:4px 10px;border:1px solid var(--border);border-radius:999px;color:var(--accent);font-weight:600;margin-bottom:8px}
        #tokenomics2 h1{font-size:26px;font-weight:800;margin-bottom:4px}
        #tokenomics2 p.subtitle{color:var(--muted);font-size:14px;margin-bottom:16px}

        #tokenomics2 ul{list-style:none;display:flex;flex-direction:column;gap:14px;padding:0;margin:0}
        #tokenomics2 li{background:var(--card);border:1px solid var(--border);border-radius:12px;padding:16px}
        #tokenomics2 li h3{margin-bottom:6px;font-size:18px}
        #tokenomics2 li p{margin:0;color:var(--muted);font-size:14px}

        #tokenomics2 .bar{height:8px;border-radius:999px;background:#202733;overflow:hidden;margin-top:4px}
        #tokenomics2 .fill{height:100%;background:var(--accent)}
        #tokenomics2 .row{display:flex;justify-content:space-between;gap:8px}

        #tokenomics2 footer{margin-top:24px;font-size:12px;color:var(--muted);text-align:center}

        @media(min-width:600px){
          #tokenomics2 h1{font-size:30px}
          #tokenomics2 li h3{font-size:20px}
        }
      `}</style>

      <div style={{ maxWidth: 700, margin: '0 auto' }}>
        <header>
          <h1>
            Billboards ({total})
          </h1>
          <p className='subtitle'>
            List of billboard locations and related X posts
          </p>
        </header>
        <ul>
          {posts.map((marker) =>
            marker.billboards.map((billboard) => (
              <li style={{display: 'flex', flexDirection:'column', justifyContent:'center', alignItems: 'center'}}>
                <a
                  href={`https://maps.google.com/?q=${marker.position}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{color: 'white'}}
                >
                  {marker.title} - {billboard.subtitle}
                </a>
                <a
                  href={billboard.xUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: '#6ab8ff', textDecoration: 'underline', marginTop: '10px' }}
                >
                  See on X
                </a>
              </li>
            ))
          )}
        </ul>
      </div>
    </main>
  )
}
